export const BLACK = 1059;
export const GRAY = 1060;
export const WHITE = 1061;
export const SILVER = 1062;
export const BROWN = 1063;
export const RED = 1064;
export const BLUE = 1065;
export const GREEN = 1066;
export const BEIGE = 1067;
export const YELLOW = 1068;
export const ORANGE = 1069;
export const PURPLE = 1070;
export const GOLD = 1071;
